/**
 * Detects and ignores an error that is caused by a Chrome extension for Google Tag Manager
 *
 * @param {object} report the Report Object
 * @returns {boolean} Returns true if the report matches
 * @example
 *      "Cannot redefine property: googletag"
 */
function googleTagError(report) {
  if (report.errorMessage.includes("googletag")) {
    report.ignore();

    return true;
  }

  return false;
}

export default googleTagError;
